import { Component, OnInit } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { TerminalsService } from 'src/app/modules/finance/services/terminals.service';
import { TableLazyLoadEvent } from 'primeng/table';
import {
  TableAction,
  TableColumn,
} from 'src/app/shared/models/table-config.model';

@Component({
  selector: 'app-terminal-list-modal',
  templateUrl: './terminal-list-modal.component.html',
  standalone: false,
})
export class TerminalListModalComponent implements OnInit {
  terminals: any[] = [];
  allTerminals: any[] = [];
  totalItems = 0;
  loading = true;
  filter = '';
  portId: number;

  tableColumns: TableColumn[] = [
    { field: 'idTerminal', header: 'ID', type: 'text', width: '20%' },
    { field: 'nmTerminal', header: 'TERMINAL', type: 'text', width: 'auto' },
    { field: 'actions', header: '', type: 'actions', width: '15%' },
  ];

  tableActions: TableAction[] = [
    {
      label: 'Select',
      styleClass: 'p-button-outlined p-button-secondary font-bold h-8 text-xs',
      command: (row) => this.ref.close({ terminal: row }),
    },
  ];

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private terminalsService: TerminalsService,
  ) {}

  ngOnInit() {
    this.portId = this.config.data?.portId;
    this.loadAll();
  }

  loadAll() {
    if (!this.portId) {
      this.loading = false;
      return;
    }
    this.loading = true;
    // Busca terminais filtrados pelo Porto selecionado no Scope
    this.terminalsService
      .getPaginatedTerminals(1000, 0, '', this.portId)
      .subscribe({
        next: (data: any) => {
          this.allTerminals = data.terminals || [];
          this.totalItems = this.allTerminals.length;
          this.processData({ first: 0, rows: 10 });
        },
        error: () => (this.loading = false),
      });
  }

  loadLazy(event: TableLazyLoadEvent) {
    if (this.allTerminals.length) this.processData(event);
  }

  processData(event: TableLazyLoadEvent) {
    this.loading = true;
    let processed = [...this.allTerminals];
    if (this.filter) {
      const lower = this.filter.toLowerCase();
      processed = processed.filter((t) =>
        t.nmTerminal?.toLowerCase().includes(lower),
      );
    }
    this.totalItems = processed.length;
    const first = event.first || 0;
    this.terminals = processed.slice(first, first + (event.rows || 10));
    setTimeout(() => (this.loading = false), 100);
  }

  handleSearch(val: string) {
    this.filter = val;
    this.processData({ first: 0, rows: 10 });
  }

  closeModal() {
    this.ref.close();
  }
}
